var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconIspGuide(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "menu_book_black_24dp",
    transform: "translate(0 -0.055)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\u30B0\\u30EB\\u30FC\\u30D7_1122",
    "data-name": "\\u30B0\\u30EB\\u30FC\\u30D7 1122"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "\\u9577\\u65B9\\u5F62_809",
    "data-name": "\\u9577\\u65B9\\u5F62 809",
    width: 20,
    height: 20,
    transform: "translate(0 0.055)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "\\u30B0\\u30EB\\u30FC\\u30D7_1125",
    "data-name": "\\u30B0\\u30EB\\u30FC\\u30D7 1125",
    transform: "translate(0.836 3.76)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\u30B0\\u30EB\\u30FC\\u30D7_1124",
    "data-name": "\\u30B0\\u30EB\\u30FC\\u30D7 1124"
  }, /*#__PURE__*/React.createElement("path", {
    id: "\\u30D1\\u30B9_585",
    "data-name": "\\u30D1\\u30B9 585",
    d: "M17.713,4.918A9.864,9.864,0,0,0,14.788,4.5a7.772,7.772,0,0,0-4.6,1.253A7.772,7.772,0,0,0,5.6,4.5,7.772,7.772,0,0,0,1,5.753V18a.449.449,0,0,0,.418.418c.084,0,.125-.042.209-.042A10.2,10.2,0,0,1,5.6,17.452a7.772,7.772,0,0,1,4.6,1.253,10.065,10.065,0,0,1,4.6-1.253,8.505,8.505,0,0,1,3.969.877.377.377,0,0,0,.209.042.449.449,0,0,0,.418-.418V5.753A5.7,5.7,0,0,0,17.713,4.918Zm0,11.281a9.71,9.71,0,0,0-2.925-.418,10.065,10.065,0,0,0-4.6,1.253V7.425a10.065,10.065,0,0,1,4.6-1.253,9.71,9.71,0,0,1,2.925.418Z",
    transform: "translate(-1 -5.5)",
    fill: "#72383D"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconIspGuide);
export default __webpack_public_path__ + "static/media/icon_isp_guide.9a8c22edb2aa3118681b96f2c63a2b6e.svg";
export { ForwardRef as ReactComponent };